import { useSelector } from 'react-redux';
import { colors } from '../../../theme/colors';
import spacing from '../../../theme/spacing';
import { RootState } from '../../../redux/store';
import { useState } from 'react';
import { ButtonBase } from '@mui/material';
import { MIN_LOCATION_ITEM_HEIGHT } from '../styles';
import MaximumNumberLocationsButtonContent from '../MaximumNumberLocationsButtonContent';
import AddAnotherLocationButtonContent from './AddAnotherLocationButtonContent';

export const MAX_NUMBER_OF_LOCATIONS = 10;

interface AddAnotherLocationButtonProps {
  onAddNewOpenLocation: () => void;
  onShowLocationRemoval: () => void;
}

const AddAnotherLocationButton = ({
  onShowLocationRemoval,
  onAddNewOpenLocation,
}: AddAnotherLocationButtonProps) => {
  const userLocations = useSelector((state: RootState) => state.user.locations);

  const [isMaximumLocationsMessageShown, setIsMaximumLocationsMessageShown] =
    useState(false);

  const isMaximumLocationsReached =
    userLocations.length >= MAX_NUMBER_OF_LOCATIONS;

  const onClick = () => {
    if (isMaximumLocationsReached) {
      isMaximumLocationsMessageShown
        ? onShowLocationRemoval()
        : setIsMaximumLocationsMessageShown(isMaximumLocationsReached);
    } else {
      onAddNewOpenLocation();
    }
  };

  return (
    <ButtonBase
      onClick={onClick}
      style={{
        paddingTop: spacing.medium,
        paddingBottom: spacing.medium,
        background: 'transparent',
        display: 'block',
        width: '100%',
        textAlign: 'left',
        minHeight: MIN_LOCATION_ITEM_HEIGHT,
        borderBottom: `1px solid ${colors.backgroundSuperLight}`,
      }}
    >
      {isMaximumLocationsMessageShown && isMaximumLocationsReached ? (
        <MaximumNumberLocationsButtonContent />
      ) : (
        <AddAnotherLocationButtonContent />
      )}
    </ButtonBase>
  );
};

export default AddAnotherLocationButton;
